'use strict';

/* eslint no-console:0 */
function camelCase(name) {
  return name.charAt(0).toUpperCase() + name.slice(1).replace(/-(\w)/g, function (m, n) {
    return n.toUpperCase();
  });
}

// Just import style for https://github.com/ant-design/ant-design/issues/3745
var req = require.context('./components', true, /^\.\/[^_][\w-]+\/(style\/)index\.tsx?$/);

req.keys().forEach(function (mod) {
  var v = req(mod);
  if (v && v["default"]) {
    v = v["default"];
  }
  var match = mod.match(/^\.\/([^_][\w-]+)\/index\.tsx?$/);
  if (match && match[1]) {
    if (match[1] === 'message' || match[1] === 'notification') {
      // message & notification should not be capitalized
      exports[match[1]] = v;
    } else {
      exports[camelCase(match[1])] = v;
    }
  }
});

module.exports = require('./components');


/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 272
 ** module chunks = 0
 **/